import { StoreSnapshot } from 'types/insights'
import { formatCompactCurrency, stringToTitleCase } from '../utils'

export const determineValue = (
    snapshot: StoreSnapshot[keyof StoreSnapshot],
) => {
    if (snapshot?.dollars !== undefined && snapshot.dollars !== null) {
        return formatCompactCurrency(snapshot.dollars)
    } else if (
        snapshot?.transactions !== undefined &&
        snapshot.transactions !== null
    ) {
        return snapshot.transactions.toLocaleString()
    } else {
        return '-'
    }
}

export const formatDistrictChange = (
    snapshot: StoreSnapshot[keyof StoreSnapshot],
): string => {
    const percentChange = snapshot?.percent_change_from_district_last_year
    return percentChange !== undefined && percentChange !== null
        ? `${percentChange.toFixed(2)}%`
        : '-'
}

export interface SnapshotRow {
    [key: string]: string | null | undefined
    metric: string | null
    value: string
    district: string
    takeaway?: string
}

export const buildSnapshotRows = (data: StoreSnapshot): SnapshotRow[] =>
    Object.entries(data).map(([key, snapshot]) => ({
        metric: stringToTitleCase(key),
        value: determineValue(snapshot),
        district: formatDistrictChange(snapshot),
        takeaway: snapshot?.takeaway,
    }))
